import { Button, Spin } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import ReactDOM from "react-dom";
import { useRef, FC } from "react";
import { Styled, StyledWrapper } from "./styled";
import { AiOutlineColumnWidth } from "react-icons/ai";
import useModalPreviewOffice, { IProps } from "./hook";
import React from "react";
import IconResize from "./IconResize";
const ModalPreviewOfficeLayout = (
  props: ReturnType<typeof useModalPreviewOffice>,
) => {
  const {
    modalProps,
    isResizing,
    setIsResizing,
    refContainer,
    loading,
    nameFile,
    renderPreview,
  } = props;

  return ReactDOM.createPortal(
    <StyledWrapper>
      <Styled ref={refContainer}>
        {isResizing && <div className="iframe-overlay"></div>}
        <div
          className={`container-button-resize ${isResizing && "resizing"}`}
          onMouseDown={() => setIsResizing(true)}
          onMouseUp={() => setIsResizing(false)}
        >
          <IconResize />
        </div>

        <div
          style={{
            position: "absolute",
            right: 0,
            top: 0,
            padding: 5,
            cursor: "pointer",
          }}
          onClick={(e) => modalProps.onCancel && modalProps.onCancel(e)}
        >
          <CloseOutlined />
        </div>

        <Spin
          spinning={loading}
          style={{
            maxHeight: "calc(100vh - 148px)",
          }}
        >
          <h3
            style={{
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
              fontWeight: 700,
            }}
          >
            {nameFile}
          </h3>
          {renderPreview()}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "",
            }}
          >
            {/* <div
            style={{
              width: 200,
            }}
          >
            <ZoomControl
              max={400}
              min={10}
              unit="%"
              initValue={100}
              element={refContainerGird?.current}
            />
          </div> */}
          </div>
        </Spin>
      </Styled>
    </StyledWrapper>,
    document.getElementById("root") as HTMLElement,
  );
};

const ModalPreviewOffice: FC<IProps> = (props: IProps) => (
  <ModalPreviewOfficeLayout {...useModalPreviewOffice(props)} />
);

export default ModalPreviewOffice;
